import { Link } from 'react-router';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// What the invitation page says once there is nothing left to answer:
// connected, with the diary now shared (C38), declined, or no longer open. The last is one sentence for every
// reason an invitation is not open to this person, so it tells a stranger
// with the link nothing.
export function InvitationOutcome({ outcome, clinician }) {
  const { text } = useLanguage();

  if (outcome === 'accepted') {
    const name = `${ clinician.firstName } ${ clinician.lastName }`;

    return (
      <section className={ styles.card }>
        <span className={ styles.check } aria-hidden='true'></span>

        <h1 className={ styles.title }>{ text.connectedWith.replace('{name}', name) }</h1>

        <p className={ styles.text }>{ text.diaryNowShared.replace('{name}', name) }</p>

        <div className={ styles.links }>
          <Link className={ styles.primary } to='/'>{ text.goToToday }</Link>
        </div>
      </section>
    );
  }

  if (outcome === 'declined') {
    const name = `${ clinician.firstName } ${ clinician.lastName }`;

    return (
      <section className={ styles.card }>
        <h1 className={ styles.title }>{ text.invitationDeclined }</h1>

        <p className={ styles.text }>{ text.declinedExplained.replace(/\{name\}/g, name) }</p>

        <div className={ styles.links }>
          <Link className={ styles.primary } to='/'>{ text.goToToday }</Link>
        </div>
      </section>
    );
  }

  return (
    <section className={ styles.card }>
      <h1 className={ styles.title }>{ text.invitationClosed }</h1>

      <p className={ styles.text }>{ text.invitationClosedExplained }</p>

      <div className={ styles.links }>
        <Link className={ styles.primary } to='/settings'>{ text.openSettings }</Link>
      </div>
    </section>
  );
}
